import VacationsHourly from '@/views/vacations-hourly/VacationsHourly.vue'
import VacationHourly from '@/views/vacations-hourly/VacationHourly.vue'
import { HOURLY_ABSENCE_COMPANIES } from '@/common/companies'

export default [{
    path: '/vacations-hourly',
    name: "vacationsHourly",
    component: VacationsHourly,
    meta: {
      requiresAuth: true,
      companiesAllowed: HOURLY_ABSENCE_COMPANIES,
    },
  },
  {
    path: '/vacations-hourly/new',
    name: "newVacationHourly",
    component: VacationHourly,
    meta: {
      requiresAuth: true,
      companiesAllowed: HOURLY_ABSENCE_COMPANIES,
    },
  },
  {
    path: '/vacations-hourly/:id',
    name: "editVacationHourly",
    component: VacationHourly,
    meta: {
      requiresAuth: true,
      companiesAllowed: HOURLY_ABSENCE_COMPANIES,
    },
  },
]
